<div class="row">
    <catalog-filter-item id="approved-macd-filter" [type]="CatalogFilterType.Active" class="col" />
    <catalog-filter-item id="pending-macd-filter" [type]="CatalogFilterType.Archived" class="col" />
</div>